export function areShallowEqual(a, b) {
    var aIsNull = a === null;
    var bIsNull = b === null;
    if (aIsNull !== bIsNull)
        return false;
    var aIsArray = Array.isArray(a);
    var bIsArray = Array.isArray(b);
    if (aIsArray !== bIsArray)
        return false;
    var aTypeof = typeof a;
    var bTypeof = typeof b;
    if (aTypeof !== bTypeof)
        return false;
    if (isPrimitive(aTypeof))
        return a === b;
    return aIsArray ? areArraysShallowEqual(a, b) : areObjectsShallowEqual(a, b);
}
export function areArraysShallowEqual(a, b) {
    var l = a.length;
    if (l !== b.length)
        return false;
    for (var i = 0; i < l; i++) {
        if (a[i] !== b[i])
            return false;
    }
    return true;
}
export function areObjectsShallowEqual(a, b) {
    var ka = 0;
    var kb = 0;
    for (var key in a) {
        if (a.hasOwnProperty(key) && a[key] !== b[key])
            return false;
        ka++;
    }
    for (var key in b) {
        if (b.hasOwnProperty(key))
            kb++;
    }
    return ka === kb;
}
function isPrimitive(type) {
    return type !== 'function' && type !== 'object';
}
